var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Progress } from 'semantic-ui-react';
import styled from 'styled-components';
import useActiveThemeVariation from '../../../../themes/hooks/UseActiveThemeVariation';
var StyledProgressBar = styled(Progress)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nbackground:  ", " !important;\nheight: ", "px !important;\n\n  & > .bar {\n    background-color: ", " !important;\n    height: ", "px !important;\n    margin-top: ", "px !important\n  }\n"], ["\nbackground:  ", " !important;\nheight: ", "px !important;\n\n  & > .bar {\n    background-color: ", " !important;\n    height: ", "px !important;\n    margin-top: ", "px !important\n  }\n"])), function (props) { return props.background || 'rgba(0,0,0,.1)'; }, function (props) { return props.sharedStyle.height; }, function (props) { return props.customColor || 'green'; }, function (props) { return props.sharedStyle.height; }, function (props) { return props.backgroundHeightOffset / 2; });
import React, { useMemo } from 'react';
import useTheme from '../../../../themes/hooks/UseTheme';
var ProgressBar = function (props) {
    var theme = useTheme();
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.advancedControlsThemes.progressBar; });
    var sharedStyle = theme.advancedControlsThemes.progressBar.getStyleObjectBuilder(props, 'height').build();
    var value = props.value;
    var type = activeThemeVariation.type, active = activeThemeVariation.active, backgroundHeightOffset = activeThemeVariation.backgroundHeightOffset;
    var color = theme.resolveColor(activeThemeVariation.color);
    var background = theme.resolveColor(activeThemeVariation.background);
    var progress = useMemo(function () {
        switch (type) {
            case 'ratio':
                return 'ratio';
            case 'value':
                return 'value';
            case 'percentage':
                return 'percent';
            default:
                return false;
        }
    }, [type]);
    var activeBackgroundHeightOffset = backgroundHeightOffset || 0;
    // ToDO: implement value correctly (using total & value)
    return (React.createElement(StyledProgressBar, { customColor: color, background: background, percent: value, progress: progress, sharedStyle: sharedStyle, active: active, backgroundHeightOffset: activeBackgroundHeightOffset, x: true }));
};
export default ProgressBar;
var templateObject_1;
//# sourceMappingURL=ProgressBarImplementation.js.map